/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for DocumentService.
 *
 */

import { ReduxUtils } from '@spm/core';
var POST_DBS_FILES = ReduxUtils.generatePostActionTypes('ua-library', "DOCUMENTSERVICE/POST_DBS_FILES");
var GET_DBS_FILES_BY_FILE_ID = ReduxUtils.generateFetchActionTypes('ua-library', "DOCUMENTSERVICE/GET_DBS_FILES_BY_FILE_ID");
var DELETE_DBS_FILES_BY_FILE_ID = ReduxUtils.generateActionTypes('ua-library', "DOCUMENTSERVICE/DELETE_DBS_FILES_BY_FILE_ID", 'DELETE');
export { POST_DBS_FILES, GET_DBS_FILES_BY_FILE_ID, DELETE_DBS_FILES_BY_FILE_ID };